module.exports = __webpack_public_path__ + "img/remove.98476720.svg";